<div class="quote-totals-container mt-2">
  <div class="tabs-container">
    @for (tab of tabs; track $index) {
      <div class="tab bg-blue-500">
        @if (tab.label) {
          {{ tab.label }}: {{ tab.quantity }}{{ tab.suffix }}
        } @else {
          {{ tab.firstValue | currency: 'USD' : 'symbol' : '1.0-3' }} /
          {{ tab.secondValue | number: '1.0-0' }}{{ tab.suffix }}
        }
      </div>
    }
  </div>
</div>
